import React from "react";

const FramePage = () => {
  return (
    <div style={styles.container}>
      <iframe
        title="My Frame"
        src="/channel-proxy/"
        style={styles.iframe}
        frameBorder="0"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin"
      />
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    height: "100vh",
    padding: "10px",
    boxSizing: "border-box",
  },
  title: {
    textAlign: "center",
    marginBottom: "10px",
  },
  iframe: {
    width: "100%",
    height: "90%",
    border: "1px solid #ccc",
  },
};

export default FramePage;